import { takeLatest } from "redux-saga/effects";
import { apis } from "../../config/APIs";
import { sagaFunctions } from "../../utils";
import {
  Login,
  Logout,
  ResetPassword,
  ChangePassword,
  ForgotPassword,
  Notifications,
  RequestDemo,
} from "./auth";

function login(req) {
  return sagaFunctions(Login, "post", apis.login, req.payload, {
    headers: {
      deviceType: "web",
    },
  })();
}

function requestDemo(req) {
  return sagaFunctions(RequestDemo, "post", apis.inquiry, req.payload)();
}

function notifications(req) {
  return sagaFunctions(Notifications, "get", apis.notifications, req.payload, {
    skipSuccessMessage: true,
  })();
}

function logout(req) {
  return sagaFunctions(Logout, "post", apis.logout)();
}

function forgotPassword(req) {
  return sagaFunctions(
    ForgotPassword,
    "post",
    apis.forgotPassword,
    req.payload,
    {
      "Content-Type": "multipart/formdata",
    },
  )();
}

function resetPassword(req) {
  return sagaFunctions(ResetPassword, "post", apis.resetPassword, req.payload, {
    "Content-Type": "multipart/formdata",
  })();
}

function changePassword(req) {
  return sagaFunctions(
    ChangePassword,
    "post",
    apis.changePassword,
    req.payload,
    {
      "Content-Type": "multipart/formdata",
    },
  )();
}

export function* loginWatcher() {
  yield takeLatest(Login.REQUEST, login);
  yield takeLatest(RequestDemo.REQUEST, requestDemo);
  yield takeLatest(Logout.REQUEST, logout);
  yield takeLatest(ForgotPassword.REQUEST, forgotPassword);
  yield takeLatest(ResetPassword.REQUEST, resetPassword);
  yield takeLatest(ChangePassword.REQUEST, changePassword);
  yield takeLatest(Notifications.REQUEST, notifications);
}
